import TextView from "../textview/TextView";
import RatingBar from "../ratingbar/RatingBar";

const ProductCardMobile = ({ image, title, price, rating }) => {
  return (
    
    <div className="d-flex align-items-center border-bottom shadow-sm p-2">
      <img
        src={image}
        alt={title}
        style={{
          width: "100px",
          height: "100px",
          objectFit: "contain",
          flexShrink: 0,
        }}
      />

      <div className="ms-2 flex-grow-1">
        <TextView text={title} size="sm" bold={false} />
        <RatingBar value={rating} />
        <TextView text={`${price}$`} size="sm" color="success" bold={true} />
      </div>
    </div>
  );
};

export default ProductCardMobile;
